import React from 'react';
import { InView } from 'react-intersection-observer';
import '../styles/InnovationSection.css';
import manWorking from '../../assets/man-working.png';
import womanOncall from '../../assets/woman-oncall.png';
import jigsawPuzzle from '../../assets/jigsaw-puzzle.png';
import industryConnect from '../../assets/industry-connect.png';

const InnovationSection = () => {
  return (
    <section className="innovation-section">
      <div className="innovation-container">
        <InView triggerOnce={true} threshold={0.1}>
          {({ inView, ref }) => (
            <header ref={ref} className={`innovation-header ${inView ? 'animate' : ''}`}>
              <h1>Microsoft Innovation.</h1>
              <h1><span className="company-name">SYNECT<span className="company-name-red-i">I</span>KS</span> Execution. Seamless Results.</h1>
            </header>
          )}
        </InView>
        <main className="innovation-boxes">
          <InView triggerOnce={true} threshold={0.1}>
            {({ inView, ref }) => (
              <article ref={ref} className={`innovation-box ${inView ? 'animate' : ''}`}>
                <figure>
                  <img src={manWorking} alt="Professional working with Microsoft technologies" />
                </figure>
                <header>
                  <h3>Microsoft-Certified Expertise</h3>
                </header>
                <p>Our official Microsoft Partner status reflects a deep commitment to innovation, quality, and staying ahead with the latest technologies.</p>
              </article>
            )}
          </InView>
          <InView triggerOnce={true} threshold={0.1}>
            {({ inView, ref }) => (
              <article ref={ref} className={`innovation-box ${inView ? 'animate' : ''}`}>
                <figure>
                  <img src={womanOncall} alt="Professional providing 24/7 support services" />
                </figure>
                <header>
                  <h3>"On Call, On Point - 24/7/365"</h3>
                </header>
                <p>Our consultants bring hands-on experience and certifications across Microsoft platforms, ensuring every solution is built for long-term success.</p>
              </article>
            )}
          </InView>
          <InView triggerOnce={true} threshold={0.1}>
            {({ inView, ref }) => (
              <article ref={ref} className={`innovation-box ${inView ? 'animate' : ''}`}>
                <figure>
                  <img src={jigsawPuzzle} alt="Puzzle pieces representing customized business solutions" />
                </figure>
                <header>
                  <h3>Solutions Built Around You</h3>
                </header>
                <p>We don't believe in one-size-fits-all. Every strategy is tailored to meet your unique business goals and challenges.</p>
              </article>
            )}
          </InView>
          <InView triggerOnce={true} threshold={0.1}>
            {({ inView, ref }) => (
              <article ref={ref} className={`innovation-box ${inView ? 'animate' : ''}`}>
                <figure>
                  <img src={industryConnect} alt="Network connections representing cross-industry expertise" />
                </figure>
                <header>
                  <h3>Proven Success Across Industries</h3>
                </header>
                <p>From education to enterprise, we've delivered measurable outcomes for clients across a wide range of sectors.</p>
              </article>
            )}
          </InView>
        </main>
      </div>
    </section>
  );
};

export default InnovationSection;